import React from "react"

export function SignatureIcon() {
    return (
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
                <g id="2.signature-copy" transform="translate(-38.000000, -156.000000)">
                    <g id="noun_347_cc-copy" transform="translate(38.000000, 156.000000)">
                        <g id="Group">
                            <path
                                d="M1.13856,1.36467327 C-0.37944,2.86764356 -0.37944,5.304 1.13856,6.8069703 L6.63504,1.36467327 C5.11728,-0.13829703 2.65632,-0.13829703 1.13856,1.36467327 L1.13856,1.36467327 Z"
                                id="Shape"
                            ></path>
                            <path
                                d="M14.61432,20.1490693 L24,24 L20.1108,14.7072475 L8.13936,2.85457426 L2.64288,8.29639604 L14.61432,20.1490693 L14.61432,20.1490693 Z M15.8652,17.7376634 C16.36488,17.2424554 17.31072,17.3771881 17.51952,17.5839208 C17.3112,17.3776634 17.17488,16.4404752 17.67456,15.9457426 C18.17424,15.4510099 19.17264,15.2751683 19.17264,15.2751683 L21.40752,20.6145743 L20.58048,21.4334257 L15.18768,19.2209109 C15.18768,19.2211485 15.36552,18.2326337 15.8652,17.7376634 L15.8652,17.7376634 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
